import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _name$filters$compone;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getShiftInfoList, postDownloadShopStockHistory } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';

var _this;

export default (_name$filters$compone = {
  name: 'ShiftInformation',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  components: {},
  data: function data() {
    var that = this;
    return {
      stationOptions: [],
      shiftNoStarts: [],
      shiftNoEnds: [],
      startTime: '',
      endTime: '',
      formatDate: {},
      pickerOptionsStart: {},
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var curDate = new Date(that.startTime).getTime();
          return time.getTime() < curDate;
        }
      }
    };
  }
}, _defineProperty(_name$filters$compone, "filters", {
  formatDate: function formatDate(time) {
    if (time != null && time !== '') {
      var date = new Date(time);
      return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
    } else {
      return '';
    }
  }
}), _defineProperty(_name$filters$compone, "beforeCreate", function beforeCreate() {
  _this = this;
}), _defineProperty(_name$filters$compone, "created", function created() {
  var _this2 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var stationOptions;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 使用keepalive的页面,重新展示不会调用
            console.log('created');
            _context.next = 3;
            return getStationBaseInfoList({
              page: 1,
              pageSize: 999999,
              donNotShowLoading: true
            });

          case 3:
            stationOptions = _context.sent;
            _this2.stationOptions = stationOptions.data.list;

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();
}), _defineProperty(_name$filters$compone, "methods", {
  shiftNoStartChange: function shiftNoStartChange(time) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var times, stationOptions;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              times = formatTimeToStr(time, 'yyyyMMdd');
              _context2.next = 3;
              return getShiftInfoList({
                page: 1,
                pageSize: 10,
                stationId: _this3.formatDate.stationId,
                shiftDate: times
              });

            case 3:
              stationOptions = _context2.sent;

              if (stationOptions.code == 0) {
                _this3.shiftNoStarts = stationOptions.data.list;
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  shiftNoStartSelectChange: function shiftNoStartSelectChange(shiftNo) {
    var that = this;
    that.shiftNoStarts.forEach(function (item) {
      if (shiftNo == item.shiftNo) {
        console.log(item);
        that.formatDate.startTime = formatTimeToStr(item.startDate, 'yyyy-MM-dd hh:mm:ss');
      }
    });
  },
  shiftNoEndChange: function shiftNoEndChange(time) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var times, stationOptions;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              times = formatTimeToStr(time, 'yyyyMMdd');
              _context3.next = 3;
              return getShiftInfoList({
                page: 1,
                pageSize: 10,
                stationId: _this4.formatDate.stationId,
                shiftDate: times
              });

            case 3:
              stationOptions = _context3.sent;

              if (stationOptions.code == 0) {
                _this4.shiftNoEnds = stationOptions.data.list;
              }

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  shiftNoEndSelectChange: function shiftNoEndSelectChange(shiftNo) {
    var that = this;
    that.shiftNoEnds.forEach(function (item) {
      if (shiftNo == item.shiftNo) {
        console.log(item);
        that.formatDate.endTime = formatTimeToStr(item.endDate, 'yyyy-MM-dd hh:mm:ss');
      }
    });
  },
  onSubmit: function onSubmit() {
    var _this5 = this;

    var that = this;
    console.log(that.formatDate);
    postDownloadShopStockHistory(that.formatDate).then(function (res) {
      console.log(res);

      if (res.code === 0) {
        _this5.$message({
          message: res.msg,
          type: 'success'
        });
      }
    }, function (err) {});
  }
}), _name$filters$compone);